import {type OrchestrationJob} from "./Orchestration";
import {type TransformationJob} from "./Transformation";

export type TypedJob = OrchestrationJob | TransformationJob

export function isOrchestrationJob(job: TypedJob): job is OrchestrationJob {
    return "basicConnectors" in job
}

export function isTransformationJob(job: TypedJob): job is TransformationJob {
    return !isOrchestrationJob(job)
}

export interface OrchJobHolder {
    job: OrchestrationJob
    name: string
    path: string[]
    type: "ORCHESTRATION"
}

export interface TransJobHolder {
    job: TransformationJob
    name: string
    path: string[]
    type: "TRANSFORMATION"
}

export type JobHolder = OrchJobHolder | TransJobHolder